module.exports = __webpack_public_path__ + "img/shezhi.69eb1138.svg";